
import "/app/src/components/AudioWorkspace/index.module.less?modules";
export default {"player": `player-M5RYwEvZ`,"wave": `wave-Si6gqycA`}
